var render = function render(){var _vm=this,_c=_vm._self._c;return _c('plmDownLoad',_vm._g(_vm._b({ref:"downLoad"},'plmDownLoad',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }